import find from 'lodash.find';
import Cart from '../Cart/Cart';
import Review from "./Review";
import {DialogAlert} from "../../../dialogs";

const $ = require('jquery');
require('jquery.serialize.object');
const utils = require('utils');
const Button = require('button');
require('bootstrap-input-spinner');
require('bootstrap-collapse');

const cart = new Cart($('.shopping-cart--product-list'), {
  btnRemoveSelector: '.remove_from_cart_button',
});

const Product = function (productData, options) {
  this.productData = productData;
  this.options = options;
  this.$form = $('#form-product');
};

Product.prototype.init = function () {
  $('input[name=units]').inputSpinner({
    min: 1,
    value: 1,
    groupClass: 'product-qty-form-control mr-2',
  });

  $('.btn-add-cart').on('click', this.addCart.bind(this));
  $('.btn-checkout').on('click', this.addCartAndCheckout.bind(this));

  if (this.productData.combinations.length > 0) {
    this.configureAttributesUI({
      priceSelector: this.options.priceSelector,
    });
  }

  if (this.options.ratingEnabled) {
    this.rating();
  }

  // Configure ProductGroup
  const $groupVariants = $('.product-variants');
  if ($groupVariants.length) {
    this.configureProductGroup();
  }
};

Product.prototype.addCart = function (event) {
  event.preventDefault();
  const $btn = $(event.currentTarget);
  let error = false;
  const $status = $('.cart-feedback');

  error = !this.validateSelection($btn, true);
  $status.hide().removeClass('alert-error');

  if ($btn.hasClass('disabled')) {
    return false;
  }

  if (error) {
    return;
  }

  const button = new Button($btn, 'loader');
  button.loading();

  return cart.add(this.$form.attr('action'), this.$form.serializeObject()).then(
    function (data) {
      button.loaded();
      this.onAddCartSuccess(data);
      return data;
    }.bind(this),
    function (jqXHR, textStatus, errorThrown) {
      const data = { result: false };
      data.errors = utils.parseAjaxError(jqXHR);
      $status
        .html(`<i class="fa exclamation-triangle"></i> ${data.errors}`)
        .addClass('alert alert-danger')
        .hide()
        .removeClass('d-none')
        .show();
      button.loaded();
    }
  );
};

Product.prototype.addCartAndCheckout = function (event) {
  this.addCart(event).then(function (data) {
    window.location.href = data.checkoutLink;
  });
};

Product.prototype.validateSelection = function ($btn, pre) {
  const data = $('#form-product').serializeObject();
  const $control_size = $('.control-group.attribute-key-size');
  const $control_color = $('.control-group.attribute-type-color');
  const errors = [];
  let $attributes = null;

  $control_size.removeClass('error').find('span.help-inline').remove();
  $control_color.removeClass('error').find('span.help-inline').remove();

  $attributes = $('.attribute');
  if ($attributes.length > 0) {
    if (!data['attribute[1]']) {
      errors.push('Por favor escoge una talla.');

      if (pre === true) {
        $control_size
          .addClass('error')
          .find('.controls')
          .append(
            '<span class="help-inline">' +
              'Escoge una opción por favor.' +
              '</span>'
          );
      }
    }
  }

  if (pre === true) {
    return errors.length <= 0;
  }
  if (errors.length > 0) {
    $btn.addClass('disabled');
  } else {
    $btn.removeClass('disabled');
  }
};

Product.prototype.onAddCartSuccess = function (data) {
  if (data.result) {
    this.options.onAddCartSuccess(data);
  } else {
    DialogAlert({
      title: 'Añadir al carrito',
      text: typeof data.errors === 'undefined'
        ? 'Ha ocurrido un error y no se ha podido añadir el producto al carrito.'
        : data.errors,
      icon: 'error'
    })
  }
};

Product.prototype.configureProductGroup = function () {
  $('.product-variants .btn').on('click', function (event) {
    if ($(event.currentTarget).hasClass('variant--soldout')) {
      event.stopPropagation();
    }
  });

  $('input[name="id"]:radio').on(
    'change',
    function (event) {
      const selectedProductID = $('input[name="id"]:checked').val();
      if (
        typeof this.productData.group.productVariants[selectedProductID] ===
        'undefined'
      ) {
        throw new Error(
          `Selected ProductVariant not found: ${selectedProductID}`
        );
      }

      const variant = this.productData.group.productVariants[selectedProductID];

      // Update UI data
      const $wrapper = $('.product-price');
      let html = '';
      if (variant.price.hasDiscount) {
        html =
          `<span class="price-discounted">${renderPrice(
            variant.price.price
          )}</span>` +
          `<s class="price-original">${renderPrice(
            variant.price.originalPrice
          )}</s>`;
      } else {
        // Price
        html = `<span class="price-original">${renderPrice(
          variant.price.price
        )}</span>`;
      }

      $wrapper.html(html);

      // todo add `?variant=variant.product_id`

      // Stock info
      $('input[name=units]').prop('max', variant.inventory.stock);
      if (variant.inventory.stock < 1) {
        // Mark product as soldout
        $('.product-btn-actions--enabled')
          .addClass('d-none')
          .removeClass('d-sm-flex');
        $('.product-btn-actions--disabled')
          .removeClass('d-none')
          .addClass('d-sm-flex');
        $('.product-tag--soldout').show();
      } else {
        $('.product-btn-actions--enabled')
          .removeClass('d-none')
          .addClass('d-sm-flex');
        $('.product-btn-actions--disabled')
          .addClass('d-none')
          .removeClass('d-sm-flex');
        $('.product-tag--soldout').hide();
      }

      // Image
      const $image = $(
        `.product-image--thumbnails [data-product-id="${variant.product_id}"] img`
      );
      if ($image.length > 0) {
        $image.eq(0).trigger('click');
      }
    }.bind(this)
  );

  $('input[name="id"]:checked').trigger('change');
};

function renderPrice(amount) {
  const enter = Math.floor(amount);
  const remainder = (Number(amount) % 1).toFixed(2).substring(2);
  // remainder = Number(remainder[0] + remainder[1]);

  let html = `${
    '<span class="price">' + '<span class="price--enter">'
  }${enter}</span>`;
  if (remainder > 0) {
    html += `<span class="price--decimal">,${remainder}</span>`;
  }
  html += '<span class="price--currency">&euro;</span>' + '</span>'; // .price

  return html;
}

/**
 * Configura la selección de atributos.
 * Los atributos están jerarquizados de forma secuencial
 * de manera que modificar un atributo determina
 * que opciones estarán disponibles únicamente en los
 * siguientes atributos, nunca en los anteriores.
 *
 * options:
 * - combinations
 * - price
 * - updatePriceSelector: selector del elemento que desemboca el updatePriceSelector
 * - btnSelector: selector del botón "añadir al carrito". Se usa para activar/Desactivar el botón.
 */
Product.prototype.configureAttributesUI = function (options) {
  if (options.combinations.length === 0) {
    // No hay combinaciones, no hay que controlar nada
    return;
  }

  $('.attribute-group')
    .on('change', 'input, select', onChangeAttribute)
    .on('change', 'input, select', updatePictures);

  if (!options.updatePriceSelector) {
    console.error('updatePriceSelector selector not defined');
  } else {
    $(options.updatePriceSelector).on('change', updatePrice);
  }

  const $btn_addcart = $('.btn-add-cart');
  const $attributes = $('.attribute-group');
  // Ver cual es la combinación por defecto y marcarla.
  // De primeras, será la primera combinación
  let default_combination = null;
  let found = find(options.combinations, function (c) {
    return c.is_default == 1;
  });

  if (typeof found !== 'undefined') {
    default_combination = found;
  } else {
    // Buscar primera combinación con stock
    found = find(options.combinations, function (c) {
      return c.stock > 0;
    });
    if (typeof found !== 'undefined') {
      default_combination = found;
    }
  }

  if (default_combination !== null) {
    // Vamos a seleccionar los atributos de la combinación por defecto
    const attr_c = default_combination._attributes.length;
    const values = default_combination._attributes.values.map( value => value.value );

    default_combination._attributes.each((attribute) =>{
      const $group = $(`.attribute-id-${attribute.id}`);

      if (
        $group.hasClass('attribute-type-radio') ||
        $group.hasClass('attribute-type-color')
      ) {
        $group
          .find(`input[value="${attribute.value.id}"]`)
          .prop('checked', true)
          .trigger('change');
      } else if ($group.hasClass('attribute-type-select')) {
        $group.find('select').val(attribute.value.id);
      } else {
        console.error(
          `Could not find attribute \`.attribute-id-${attribute.value.id}\``,
          attribute
        );
      }
    });
  } else {
    $('.attribute-value').removeClass('selected');
  }
  // Combinación por defecto seleccionada.
  // -------------------------------------

  // Vamos a desactivar los atributos de los que no haya stock.
  if (options.stockControl) {
    const attributes_ticks = {};
    options.combinations.each( (__c) => {
      // Recorremos los atributos
      __c._attribuets.each((__a) => {
        let entry = null;
        if (typeof attributes_ticks[__a.key] !== 'undefined') {
          entry = find(attributes_ticks[__a.key], function (at) {
            return at.id == __a.value.id;
          });
          if (typeof entry === 'undefined') {
            entry = {
              id: __a.value.id,
              ticks: 0,
            };
            attributes_ticks[__a.key].push(entry);
          }
        } else {
          entry = {
            id: __a.value.id,
            ticks: 0,
          };
          attributes_ticks[__a.key] = [];
          attributes_ticks[__a.key].push(entry);
        }

        entry.ticks = __c.stock > 0 ? 1 : entry.ticks;
      });
    });

    // Ya sabemos cuales no se usan, vamos a desactivarlos
    attributes_ticks.each((__c) => {
      __c.each((__a) => {
        if (__a.ticks === 0) {
          // desactivamos!!
          // console.log('disabling...');
          $(
            `.attribute-group input[value="${__a.id}"], .attribute-group option[value="${__a.id}"]`
          )
            .prop('disabled', true)
            .parents('label')
            .addClass('disabled not-used');
        }
      });
    });
  }
  // atributos desactivados
  //

  // Al modificar el valor de un atributo
  // actualizar los atributos "inferiores" (los que se encuentran por debajo del atributo modificado.)
  function onChangeAttribute(event) {
    const $elm = $(event.currentTarget);
    const $elm_group = $elm.parents('.attribute-group');
    const value_id = parseInt($elm.val(), 10);
    const available_combinations = [];

    $elm_group.removeClass('error').find('span.help-inline').hide();

    // Vamos a ver que combinaciones usa el valor que acabamos
    // de seleccionar
    options.combinations.each((comb) => {
      const f = find(comb._attributes, function (attr) {
        return attr.value.id == value_id;
      });

      if (typeof f !== 'undefined') {
        available_combinations.push(comb);
      }
    });

    // Vamos a recorrer los `attribute-groups` siguientes para activar/desactivar las opciones
    const index = $attributes.index($elm_group);
    for (let i = index + 1; i < $attributes.length; i++) {
      var $attr = $attributes.eq(i).find('input,select');

      // SELECT
      if ($attr.is('select')) {
        // Recorremos las opciones del select para ver que
        // valores estan disponibles
        $attr.find('option').attr('disabled', true);
        available_combinations.each((comb) => {
          comb.__attributes.each((attribute) => {
            // console.log('activamos el valor:'+attribute.value.id+' ('+attribute.value.value+')');
            const $op = $attr.find(`option[value="${attribute.value.id}"]`);
            if ($op.length > 0) {
              $op.attr('disabled', false);
            }
          });
        });
      }
      // INPUT
      else if ($attr.is('input')) {
        // Es un input: Desactivar las opciones no disponibles.
        var $old_selection = $attr.filter(':checked');
        $attr
          .attr('disabled', true)
          .prop('checked', false)
          .parents('.attribute-value')
          .addClass('disabled')
          .removeClass('selected');

        available_combinations.each(goAttributes);

        function goAttributes(comb) {
          comb._attributes.each(enableInput);
        }

        function enableInput(attribute) {
          $attr.each(function (key) {
            const $input = $(this);
            if ($input.val() == attribute.value.id) {
              $input
                .attr('disabled', false)
                .parents('.attribute-value')
                .removeClass('disabled');
              // Si la opción que se tenía marcada de este grupo sigue estando activa,
              // la volvemos a activar para mantener el valor que tenia colocado el usuario.
              if ($input.val() === $old_selection.val()) {
                $input
                  .prop('checked', true)
                  .parents('label')
                  .addClass('selected');
              }
            }
          });
        }
      }
    }

    // Peculiaridades de Attribute-type-color
    if ($elm_group.hasClass('attribute-type-radio')) {
      $elm_group.find('label').removeClass('selected');
      $elm.parents('label').addClass('selected');
    }

    // Ver si el botón de añadir carrito debe activarse/desactivarse
    const $inputsGroup = $('.attribute-group');
    let any_empty = false;
    $inputsGroup.each(function () {
      const $input = $(this).find('input,select');
      const val = $input.val();

      if (($input.is('select') && val === null) || $input.val().length === 0) {
        any_empty = true;
      } else if ($input.is('input')) {
        if ($input.filter(':checked').length > 0) {
        } else {
          any_empty = true;
        }
      }
    });

    if (any_empty) {
      $btn_addcart.addClass('disabled');
    } else {
      $btn_addcart.removeClass('disabled');
    }
  }

  /**
   * Actualiza el precio comprobando si la combinación actual tiene algún modificador de precio
   * @param event
   */
  function updatePrice(event) {
    const c_index = currentCombination();
    let total = parseFloat(options.price);

    if (c_index !== null) {
      if (options.combinations[c_index].impact_price !== null) {
        total += parseFloat(options.combinations[c_index].impact_price);
      }

      $('.product-price .price-original').html(
        `${Math.round(total * 100) / 100}&euro;`
      );
    } else {
      console.error('No combination found!');
    }
  }

  /**
   * Actualiza la imagen seleccionada.
   * @param event
   */
  function updatePictures(event) {
    const c_index = currentCombination();
    // console.log( 'Current combination:', c_index );
    if (c_index !== null) {
      $('.combination-images').hide();
      $(`.comb-${options.combinations[c_index].id}`).show();
    }
  }

  // Descubre cual es la combinación seleccionada
  function currentCombination() {
    const $selected_attributes = $(
      '.attribute-group input:checked,.attribute-group select'
    );
    const selected_attributes = [];
    const len = options.combinations.length;
    let combination_index = null;

    $selected_attributes.each(function () {
      selected_attributes.push(parseInt($(this).val(), 10));
    });

    // Recorremos las combinaciones en busca de alguna que contenga
    // todos los atributos seleccionados (selected_attributes).
    for (let combIdx = 0; combIdx < len; combIdx++) {
      // Comprobar que los atributos de esta combinación encajan === con `selected_attributes`
      const attr_count = Object.keys(options.combinations[combIdx]._attributes)
        .length;

      // Esto no funciona si un producto tiene mas de un color por ejemplo
      if (attr_count == selected_attributes.length) {
        let all_found = true;
        // Vamos a montar un array con los valores de la combinación
        for (let i = 0; i < attr_count; i++) {
          if (
            selected_attributes.indexOf(
              options.combinations[combIdx]._attributes[i].value.id
            ) == -1
          ) {
            all_found = false;
            break;
          }
        }

        if (all_found) {
          combination_index = combIdx;
          break;
        }
      }
    }

    return combination_index;
  }

  // Vamos a provocar la ejecución de los onChange
  $('.product-attributes select, .product-attributes input')
    .eq(0)
    .trigger('change');
};

Product.prototype.rating = function () {
  new Review();
};

export default Product;
